<app-dialog-header [label]="this.getTitle()" i18n-label></app-dialog-header>
<!--<app-toolbar half>
  <app-tool-button text="Tancar" i18n-text (click)="this.cancel()" color="has-color-red" icon="fa-times"></app-tool-button>
</app-toolbar>-->
<app-dialog-body>
    <app-proposta-viewer *ngIf="imagesLoaded | async" [proposta]="this.proposta" (update)="this.update($event)"></app-proposta-viewer>
</app-dialog-body>
